import { useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";

const Stat = ({ label, value, sub, ok }) => (
  <div><div className="label-xs">{label}</div><div className={`text-2xl font-bold font-display ${ok === false ? "text-amber-400" : "text-slate-100"}`}>{value}</div>{sub && <div className="text-[11px] text-slate-500">{sub}</div>}</div>
);

export function PerJdStats({ pj }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="per-jd-stats">
      <Stat label="Median match" value={`${pj.median}%`} sub={`across ${pj.count} JDs`} ok={pj.median >= 60} />
      <Stat label="JDs at 75%+" value={`${pj.ge75_pct}%`} sub={`${pj.ge60_pct}% at 60%+`} />
      <Stat label="Title match" value={`${pj.title_match_pct}%`} sub="of JDs" ok={pj.title_match_pct >= 50} />
      <Stat label="Years requirement met" value={`${pj.years_ok_pct}%`} sub="of JDs" />
      <Stat label="Average" value={`${pj.avg}%`} />
    </div>
  );
}

export default function PerJdCard({ pj }) {
  const [all, setAll] = useState(false);
  if (!pj) return null;
  const rows = all ? pj.jds : pj.jds.slice(0, 8);
  return (
    <div className="card-surface space-y-4" data-testid="per-jd-card">
      <div><div className="font-semibold">Score against every JD</div>
        <div className="text-xs text-slate-400">Each JD is scored on its own keywords (Tier 1 counts 3x, Tier 2 2x, Tier 3 1x). A base resume should sit around 60-75%; tailoring per JD then pushes it to 75-80%.</div></div>
      <PerJdStats pj={pj} />
      {pj.common_missing.length > 0 && (
        <div><div className="label-xs mb-1.5">Most often missing (add only if true; tailor per JD otherwise)</div>
          <div className="flex flex-wrap gap-1.5">{pj.common_missing.map((m) => <span key={m.keyword} className="text-xs px-2 py-0.5 rounded border border-rose-500/40 text-rose-200">{m.keyword} · {m.jds} JDs</span>)}</div></div>
      )}
      <div>
        <div className="label-xs mb-1.5">Lowest-scoring JDs first</div>
        <div className="divide-y divide-border" data-testid="per-jd-table">
          {rows.map((r) => (
            <div key={r.id || r.url} className="flex items-center gap-3 py-2 text-sm">
              <span className={`w-12 font-mono font-semibold ${r.pct >= 75 ? "text-emerald-300" : r.pct >= 60 ? "text-slate-200" : "text-amber-300"}`}>{r.pct}%</span>
              <a href={r.url} target="_blank" rel="noreferrer" className="flex-1 min-w-0 truncate hover:text-blue-300">{r.title} · <span className="text-slate-400">{r.company}</span></a>
              <span className="hidden lg:block w-72 truncate text-xs text-slate-500">{r.missing.join(", ")}</span>
              <span title="Title match" className="w-5">{r.title_match ? <CheckCircle2 size={14} className="text-emerald-400" /> : <XCircle size={14} className="text-slate-600" />}</span>
              <span className={`w-16 text-xs text-right ${r.years_ok ? "text-slate-400" : "text-rose-300"}`}>{r.years_req ? `${r.years_req}+ yrs` : "-"}</span>
            </div>
          ))}
        </div>
        {pj.jds.length > 8 && <button data-testid="per-jd-toggle" onClick={() => setAll(!all)} className="mt-2 text-xs text-blue-300 hover:text-blue-200">{all ? "Show fewer" : `Show all ${pj.jds.length}`}</button>}
      </div>
    </div>
  );
}
